
<div class="flex h-screen bg-gray-100">
  <!-- Left Sidebar -->
  <aside class="sidebar">
    <div class="px-4 h-4 border-b flex items-center">

    </div>
     
    <nav class="sidebar-nav">
      <a class="sidebar-nav-item sidebar-item-vertical" routerLinkActive="sidebar-item-active" routerLink="/pages/import-size-guides">
        <i class="sidebar-item-icon si-24 si-upload" aria-hidden="true"></i>
        <span class="sidebar-item-label">Import size guides</span>
      </a>
      <a class="sidebar-nav-item sidebar-item-vertical" routerLinkActive="sidebar-item-active" routerLink="/pages/import-size-groups">
        <i class="sidebar-item-icon si-24 si-upload" aria-hidden="true"></i>
        <span class="sidebar-item-label">Import size groups</span>
      </a>
      <a class="sidebar-nav-item sidebar-item-vertical" routerLinkActive="sidebar-item-active" routerLink="/pages/integration-queue">
        <i class="sidebar-item-icon si-24 si-bullet-list-67" aria-hidden="true"></i>
        <span class="sidebar-item-label">Integration queue</span>
      </a>
      <a class="sidebar-nav-item sidebar-item-vertical" routerLinkActive="sidebar-item-active" routerLink="/pages/media-integration-log">
        <i class="sidebar-item-icon si-24 si-image" aria-hidden="true"></i>
        <span class="sidebar-item-label">Media integration log</span>
      </a>
      <a class="sidebar-nav-item sidebar-item-vertical" routerLinkActive="sidebar-item-active" routerLink="/pages/processing-queue">
        <i class="sidebar-item-icon si-24 si-bullet-list-67" aria-hidden="true"></i>
        <span class="sidebar-item-label">Processing queue</span>
      </a>
    </nav>
  </aside>

  <!-- Main Content Area -->
  <div class="flex-1 flex flex-col min-h-0">

    <!-- Main Content -->
    <main class="flex-1 min-h-0 overflow-hidden bg-gray-50">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>
